import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { createUrlTreeFromSnapshot, Router } from '@angular/router';

import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { isPp24 } from '../../../helpers/is-pp24';
import { readyOnce } from '../../../helpers/rx-operators';
import {
  PricingFeatureFacade,
  PricingFeatureObservableModel,
} from '../../../types/pricing-feature.types';
import { ProductOrderStepUrl } from '../product-order.types';

// allows to access BillingStep or directs the user through MigrationStep
export const migrationGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const nav = router.getCurrentNavigation();
  const targetPlanId = parseInt(route.parent?.params.productId, 10);

  if (nav?.extras?.state?.migrationScreenViewed === true) {
    return true;
  }

  return combineLatest({
    targetPlanTier: inject(PricingFeatureFacade)
      .getBillingPlanById(targetPlanId)
      .pipe(map(plan => plan.tier)),
    currentPlanTier: inject(PricingFeatureObservableModel).pipe(
      readyOnce,
      map(model => model.subscription?.tier),
    ),
  }).pipe(
    map(({ targetPlanTier, currentPlanTier }) => {
      const isMigrating = currentPlanTier && !isPp24(currentPlanTier) && isPp24(targetPlanTier);
      if (!isMigrating) return true;
      return createUrlTreeFromSnapshot(route, ['../', ProductOrderStepUrl.Migration]);
    }),
  );
};
